import React from 'react';
import PropTypes from 'prop-types';
import {List, Map} from 'immutable';
import CorrectAnswer from './CorrectAnswer.react';
import Button from 'sg/Button/Button.react';
import SupplementManagerModalButton from 'client/Supplements/SupplementManager/SupplementManagerModalButton.react';
import {AuthoringQuestionModelV1} from 'resources/augmented/AuthoringQuestion/AuthoringQuestionModel.v1';
import AuthoringTextInput from 'client/EditPage/V2/AuthoringTextInput/AuthoringTextInput.react';

export default class FreeEntryInput extends React.Component {
  static propTypes = {
    index: PropTypes.number,
    input: PropTypes.object,
    question: PropTypes.instanceOf(AuthoringQuestionModelV1),
    onBlur: PropTypes.func,
    onModelChange: PropTypes.func,
    validationErrors: PropTypes.instanceOf(Map)
  };

  addAnswer = () => {
    const id = this.props.input.get('id');
    const validResponse = this.props.question.getValidResponse();
    const answers = validResponse.get(id, List()).push('');
    const updatedAnswers = validResponse.set(id, answers);
    const updatedQuestion = this.props.question.setValidResponse(updatedAnswers);

    this.props.onModelChange(updatedQuestion, 'inputs');
  };

  setInputText = (e) => {
    const id = this.props.input.get('id');
    const inputs = this.props.question.getInputs().map((input) => {
      if (input.get('id') === id) {
        return input.set('text', e.target.value);
      } 
        return input;
      
    });

    const updatedQuestion = this.props.question.setInputs(inputs);
    this.props.onModelChange(updatedQuestion);
  };

  removeInput = () => {
    const id = this.props.input.get('id');
    const inputs = this.props.question.getInputs().filterNot((input) => input.get('id') === id);
    const validResponse = this.props.question.getValidResponse().remove(id);

    const updatedQuestion = this.props.question.setInputs(inputs).setValidResponse(validResponse);

    this.props.onModelChange(updatedQuestion, 'inputs');
  };

  generateCorrectAnswers() {
    const id = this.props.input.get('id');
    const answers = this.props.question.getValidResponse().get(id, List());
    return answers.map((answer, key) => {
      return (
        <CorrectAnswer
          key={key}
          answer={answer}
          index={key}
          inputId={id}
          question={this.props.question}
          onModelChange={this.props.onModelChange}
        />
      );
    });
  }

  render() {
    const {input} = this.props;
    const answers = this.props.question.getValidResponse().get(input.get('id'));
    const addAnswerText = !answers ? 'Add answer' : 'Add alternative answer';
    const inputError = this.props.validationErrors.getIn(['inputs', input.get('id')]);
    const fieldPath = `inputs,${this.props.index},text`;
    return (
      <div className='free-entry-editor__inputs'>
        <div className='free-entry-editor__prompt'>
          <AuthoringTextInput
            value={input.get('text')}
            onChange={this.setInputText}
            onBlur={this.props.onBlur}
            data-field-path={fieldPath}
            className='free-entry-editor__prompt-input'
            label='Input prompt'
            name='title'
          />
          <Button
            className='free-entry-editor__delete-btn fa fa-trash-o'
            onClick={this.removeInput}
            color='red'
            outline
            noBorder
            title='Delete input'
          />
          <SupplementManagerModalButton
            className='free-entry-editor__add-supplement-btn'
            color='blue'
            linkButton
            pathToProperty={fieldPath}
          />
        </div>
        {inputError ? <div className='a-form-input__error'>{inputError}</div> : null}
        <div className='free-entry-editor__inputs-answers'>
          {this.generateCorrectAnswers()}
          <Button
            className='free-entry-editor__add-answer-btn'
            onClick={this.addAnswer}
            text={addAnswerText}
            linkButton
          />
        </div>
        <hr />
      </div>
    );
  }
}
